import http from "../../../../config/api/api.config";

const login = (user) => http.post("/auth/login", user);

const getCurrentUser = () => http.get("users/current");

const logout = () => http.post("/auth/logout");

export { login, logout, getCurrentUser };
